import { Link } from 'react-router-dom';

const Verified = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-trident-gray-50 p-4 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-green-200/40 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-trident-orange/10 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-md w-full bg-white rounded-3xl shadow-card-hover border border-trident-gray-100 p-8 text-center animate-slide-up">
        <div className="mx-auto w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mb-6 shadow-lg">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>

        <h2 className="font-display font-extrabold text-3xl text-trident-gray-900 mb-3">
          Email verified!
        </h2>
        <p className="text-trident-gray-500 mb-8">
          Your account is now fully activated. You can sign in and start using the platform.
        </p>

        <Link to="/login" className="btn-primary w-full justify-center flex items-center gap-2 py-3">
          Continue to Sign in
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </Link>

        <div className="mt-6 pt-6 border-t border-trident-gray-100 flex items-center justify-center gap-3">
          <img src="/trident-logo.png" alt="itTrident" className="h-7" />
          <div className="text-xs text-trident-gray-500 font-display font-semibold tracking-wider">
            BLOG <span className="text-trident-orange">AUTOMATION</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verified;
